{
  "stay_in_touch": {
    "button": "Rester en contact",
    "modal_title": "Rester en contact",
    "set_frequency": "Définir la fréquence",
    "no_reminders_set": "Vous n'avez défini aucun rappel Rester en contact",
    "due_date": "Date d'échéance",
    "contact": "Contact",
    "firm": "Cabinet",
    "last_interaction": "Dernière interaction",
    "select_frequency": "Sélectionner la fréquence",
    "reminder_active_message": "Le rappel Rester en contact est actif, et les contacts ont été ajoutés à Mes contacts.",
    "stay_in_touch_aria_label": "Rester en contact",
    "frequencies": {
      "every_three_months": "Chaque 3 mois",
      "every_six_months": "Chaque 6 mois",
      "every_year": "Chaque année",
      "dont_stay_in_touch": "Ne pas rester connecté",
      "every_month": "Chaque mois",
      "every_week": "Chaque semaine",
      "every_fortnight": "Aux deux semaines"
    }
  },
  "contacts": {
    "actions": {
      "add_to_my_contact": "Ajouter à Mes contacts",
      "add_contact": "Ajouter un contact",
      "remove_confirmation": "Êtes-vous sûr de vouloir supprimer ce contact",
      "remove_title": "Veuillez confirmer la suppression du contact",
      "export_contacts": "Exporter les contacts"
    },
    "table": {
      "columns": {
        "contact": "Contact",
        "company": "Entreprise",
        "location": "Localisation",
        "tags": "Tags",
        "last_interaction": "Dernière interaction"
      },
      "selection": {
        "all_selected": "Tous les {{count}} contacts sélectionnés",
        "add_to_list": "Ajouter à la liste",
        "archive": "Archiver",
        "log_new_activity": "Enregistrer une nouvelle activité",
        "add_to_list_success": "Demande envoyée. Il peut falloir quelques minutes pour voir tous les contacts dans la liste cible"
      }
    },
    "states": {
      "empty": {
        "title": "Aucun contact à examiner",
        "description": "Les nouveaux contacts apparaîtront ici pour votre examen",
        "alt_text": "Aucun contact à examiner",
        "description_list": "Aucun contact à afficher ici"
      },
      "not_found": {
        "title": "Aucun contact trouvé",
        "description": "Nous n'avons trouvé aucun contact correspondant à votre recherche",
        "alt_text": "Succès"
      }
    },
    "filters": {
      "company_type": "Type d'entreprise",
      "consent_status": "Statut du consentement",
      "company_hierarchy": "Hiérarchie de l'entreprise"
    },
    "forms": {
      "email_label": "Courriel",
      "email_required": "Le courriel est requis",
      "email_invalid": "Ceci n'est pas un courriel"
    },
    "export": {
      "title": "Mes contacts",
      "description": "Ajouter mes contacts à la liste",
      "primary_view": "vue de mes contacts"
    },
    "tabs": {
      "my_contacts": "Mes contacts"
    },

    "order_by": {
      "label": "Trier par",
      "company_name_asc": "nom d'entreprise asc",
      "company_name_desc": "nom d'entreprise desc",
      "created_at_asc": "créé à asc",
      "created_at_desc": "créé à desc",
      "first_name_asc": "prénom asc",
      "first_name_desc": "prénom desc",
      "last_interaction_asc": "dernière interaction asc",
      "last_interaction_desc": "dernière interaction desc",
      "last_name_asc": "nom de famille asc",
      "last_name_desc": "nom de famille desc",
      "total_interaction_asc": "total interaction asc",
      "total_interaction_desc": "total interaction desc"
    },
    "aria_labels": {
      "is_private_contact": "Contact privé",
      "view_contact_hierarchy": "voir la hiérarchie des contacts"
    }
  },
  "prospects": {
    "actions": {
      "search_prospects": "Rechercher des prospects"
    },
    "tabs": {
      "my_prospects": "Mes prospects"
    }
  },
  "opportunities": {
    "tabs": {
      "my_opportunities": "Mes opportunités"
    },
    "filters": {
      "referral_source": "Source de recommandation",
      "date": "Date"
    }
  },
  "companies": {
    "actions": {
      "remove_confirmation": "Êtes-vous sûr de vouloir supprimer cette entreprise",
      "remove_title": "Veuillez confirmer la suppression de cette entreprise",
      "remove_from_my_companies": "Supprimer de mes entreprises"
    },
    "order_by": {
      "label": "Trier par",
      "company_name_asc": "nom d'entreprise asc",
      "company_name_desc": "nom d'entreprise desc",
      "last_interaction_asc": "dernière interaction asc",
      "last_interaction_desc": "dernière interaction desc",
      "total_interaction_asc": "total interaction asc",
      "total_interaction_desc": "total interaction desc"
    },
    "filters": {
      "type": "Type"
    },
    "states": {
      "empty": {
        "description": "Aucune entreprise à afficher ici"
      }
    },
    "tabs": {
      "my_companies": "Mes entreprises"
    },
    "export": {
      "primary_view": "vue de mes entreprises"
    }
  },
  "journey": {
    "title": "Mon parcours",
    "errors": {
      "failed_to_set_embed_url": "Échec de la définition de l'URL d'intégration"
    }
  }
}
